import React from 'react';
import styles from './BootScreen.module.scss';
import homeScreenStyles from 'screens/HomeScreen/HomeScreen.module.scss';
import { Storage } from 'services';
import { LoaderDashboard, SkeletonVerticalNavigation } from 'components';
import { SkeletonList } from 'components/shared/GroupsSidebar/components/GroupList/SkeletonList';
import { BootNavigationBar } from 'screens/BootScreen';
import { useRouteMatch } from 'react-router-dom';
import classNames from 'classnames';

export function configureBootScreen(canShowBootScreen: boolean) {
  if (canShowBootScreen) {
    return Storage.set('canShowBootScreen', 'true');
  }
}
/**
 * Screen shown while app boots during the following steps
 * 1. Restoring cache
 * 2. Initialising translations
 */

export const BootScreen = () => {
  const homeMatch = useRouteMatch({
    path: '/',
    exact: true,
    strict: true,
    sensitive: true,
  });

  // Intentionally keep this sync instead of async
  // The overhead of putting this in an async/promise,
  // makes this noticably slower to start
  // every ms counts in BootScreen
  // localStorage.getItem('refreshToken') for web
  // localStorage.getItem('canShowBootScreen') for chrome
  const canShowBootScreen =
    (Storage.get('refreshToken') || Storage.get('canShowBootScreen')) && homeMatch;

  if (!canShowBootScreen) {
    return <></>;
  }

  return (
    <>
      <BootNavigationBar />
      <SkeletonVerticalNavigation />
      <div className={homeScreenStyles.content}>
        <div className={classNames(homeScreenStyles.contentBin, homeScreenStyles.layoutMain)}>
          <div className={homeScreenStyles.MainColumn}>
            <div className={homeScreenStyles.FeedContainer}>
              <LoaderDashboard layout="Boot" />
            </div>
          </div>
        </div>
      </div>
      <aside className={styles.peopleColumn}>
        <SkeletonList lists={3} />
      </aside>
    </>
  );
};
